'use client';

import { motion } from 'framer-motion';

export interface WizardAnimationWrapperProps {
  children: React.ReactNode;
  onNext?: boolean;
  firstStep?: boolean;
  lastStep?: boolean;
  motionKey?: number | string;
  style?: React.CSSProperties;
}

export const WizardAnimationWrapper = (props: WizardAnimationWrapperProps) => {
  const { onNext, firstStep, lastStep, motionKey, style, ...rest } = props;
  const { children } = rest;
  // use framer motion to animate the wizard
  const variants = {
    hidden: {
      opacity: 0,
      x: onNext ? 32 : -32,
    },
    firstHidden: {
      opacity: 0,
      x: -32,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.1,
        duration: 0.2,
        ease: 'easeOut',
      },
    },
    endHidden: {
      opacity: 0,
      x: 0,
      scale: 0.95,
    },
    endVisible: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: {
        scale: {
          type: 'spring',
          damping: 15,
          mass: 1,
          stiffness: 168.8,
          restDelta: 0.001,
        },
        duration: 0.8,
        delay: 0.1,
      },
    },
    exit: {
      opacity: 0,
      x: onNext ? -32 : 32,
      transition: {
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.div
      key={motionKey}
      initial={firstStep ? 'firstHidden' : lastStep ? 'endHidden' : 'hidden'}
      animate={lastStep ? 'endVisible' : 'visible'}
      exit="exit"
      variants={variants}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...style,
      }}>
      {children}
    </motion.div>
  );
};
